import { all, put, getContext, call, takeEvery } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { REQUEST_MONITOR_PRODUCT_MATCHES } from './types';
import { monitorProductMatchesSuccess, monitorProductMatchesFailure } from './reducer';

const logger = new Logger('Saga:Monitor:ProductMatches');

export function* getInsightProductMatches(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { payload, insightId } = action;

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.monitor.product_matches'),
      payload,
    );

    logger.info('Got product matches data');
    yield put(monitorProductMatchesSuccess(insightId, response.data));
  } catch (error) {
    logger.error(error);
    yield put(monitorProductMatchesFailure(insightId, error));
  }
}

export default function* userSaga() {
  return yield all([takeEvery(REQUEST_MONITOR_PRODUCT_MATCHES, getInsightProductMatches)]);
}
